<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="3" />
    <div class="yj-banner rel">
      <img src="@/assets/images/zx-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/zixun" class="f16 fw">资讯动态</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">富林活动</div>
        <div class="f16 ls3">Fu Lin Huo Dong</div>
      </div>
      <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center">
          <div class="yj-nav-box active">
            <router-link to="/zixun" class="yj-nav-link db f24">全部</router-link>
          </div>
          <div class="yj-nav-box ">
            <router-link to="/zixun" class="yj-nav-link db f24">即将开始</router-link>
          </div>
          <div class="yj-nav-box ">
            <router-link to="/zixun" class="yj-nav-link db f24">进行中</router-link>
          </div>
          <div class="yj-nav-box">
            <router-link to="/zixun" class="yj-nav-link db f24">已结束</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="wz-gonglue mt30 pb100 w1400 auto df justify_between">
      <div class="w1000">
        <div class="wz-view-tit">
          <h1 class="f32 b">富林广场一日游</h1>
          <div class="df align_center mt15">
            <div class="mr40">发布时间：2025-06-14 10:15</div>
            <div>来源：公众号</div>
          </div>
        </div>
        <div class="wz-view-text tj f16 lh18 cell_bk mt30">
          <img src="@/assets/images/spot-view-p1.png" class="db wp100" alt="">
          <p>研究发现，这是上海最早发现良渚文化墓葬的两处遗址之一。1977年，广富林遗址被列为上海市文物保护地点。1984年，上海市政府题名立碑“广富林古文化遗址”，并确定为上海古文化遗址保护地。1999年至2005年，上海博物馆再次对遗址进行调查及发掘，发现了新石器时代、周代、汉代等文化遗存。特别重要的是，发现并确认了长江下游地区，一支新的考古学文化--广富林文化，填补了该地区历史年代的缺环和文化发展的空白。发现之初，为学术谨慎起见，暂时称之为“广富林遗存”。2006年，在环太湖地区考古学术研讨会上，经专家论证正式确定广富林文化的命名。2008年到2015年，经过六万多平方米的发掘研究，广富林文化在上海和全国早期文明研究中的重要性不断突显、专业地位进一步强化。2013年，广富林遗址被国务院核定为第七批全国文物保护单位。</p>
          <p>
            骨针广场位于广富林文化遗址的核心区域，是整个园区的重要地标之一。广场中央嘉立着一根巨大的骨针雕塑，这根骨针象征着新石器时代晚期先民们的生活工具和智慧结晶。骨针不仅是古代人类制作衣物的重要工具，也是上海地区早期文明的一个重要标志。它体现了原始祖先的生活方式以及他们对自然材料的应用能力,
          </p>
          <p>
            当你走进骨针广场时，首先映入眼帘的是那根高耸入云的巨大骨针雕塑，其造型独特且极具视觉冲击力。围绕着骨针雕塑，广场地面由巨石精心堆砌而成，形成了一种原始而厚重的感觉。这种设计既是对古代建筑技艺的种致敬，也给现代游客带来了穿越时空的感受。
          </p>
        </div>
      </div>
      <div class="wz-view-other">
        <div class="pd20 bgwh">
          <h3 class="f20 b">更多攻略</h3>
          <div class="wz-view-other-item">
            <router-link to="/gonglue-view" class="wz-view-other-box df pt15 pb15 w_line" v-for="(index,item) in 5" :key="index">
              <div class="wz-view-other-text line_clamp3">深度游广富林遗址公园：挖掘历史文化背后的故事与价值！</div>
              <img src="@/assets/images/wz-p1.png" class="db ml15" width="120" height="72" alt="" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',

    }
  },
  components: { Header, Bottom,},
  methods:{

  },

}
</script>



// WEBPACK FOOTER //
// src/views/zixun/zixun-view.vue